import { useEffect, useRef, useState } from 'react';

import { useUser } from 'context/user';
import { useI18n } from 'context/i18n';
import { COOKIES, getCookie, hasAnyVoucherApplied } from 'utils/helpers';
import { IS_CAMPER } from 'utils/constants/system';

function defaultStyleElement(element, text) {
  if (!element) return;
  element.style.display = 'block';
  element.style.maxWidth = 'fit-content';
  element.style.marginTop = '1em';
  element.style.marginBottom = '0em';
  element.style.padding = '0.5em 3em';
  element.style.background = '#F8F1E8';
  element.style.fontSize = '0.75em';
  element.style.textAlign = 'center';
  element.style.animation = 'unset';
  // FIXME: a lo mejor no es necesario actualizar el texto
  element.text = text;
  element.style.color = '#000';
}

function appliedVoucherElement(element, text) {
  if (!element) return;
  element.style.visibility = 'visible';
  element.style.color = '#07b323';
  element.style.background = 'unset';
  element.style.backgroundSize = 'unset';
  element.style.animation = 'unset';
  element.style.textDecoration = 'unset';
  element.style.pointerEvents = 'none';
  element.text = text;
}

function hideElement(element) {
  if (!element) return;
  element.style.display = 'none';
}

export function useGridVouchers({ firstProducts, originalCta, autoappliedVoucher }) {
  const { t, locale } = useI18n();
  const { shouldRecalculateVouchers, activatedPrevouchers, handleActivatePrevoucher, contextFilters, increaseShouldRecalculateVouchers, appliedVoucher } =
    useUser();
  const [usrHashValue, setUsrHashValue] = useState(null);
  const intervalId = useRef(null);
  const [voucherApplied, setVoucherApplied] = useState(false);
  const [shouldIncrease, setShouldIncrease] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const cookieWatcher = () => {
        const voucher = getCookie(COOKIES.BONDS);
        const prevoucher = getCookie(COOKIES.PREVOUCHER);
        const usrhash = getCookie(COOKIES.SELLIGENT_USRHASH);

        if ((voucher || prevoucher || usrhash !== usrHashValue) && shouldIncrease) {
          setUsrHashValue(usrhash);
          setShouldIncrease(false);
          increaseShouldRecalculateVouchers();
          clearInterval(intervalId.current);
        }
      };

      intervalId.current = setInterval(cookieWatcher, 1000);
    }
    return () => clearInterval(intervalId.current);
  }, []);

  useEffect(() => {
    const cta = document.getElementsByClassName('subclaimcta');

    if (cta[0] !== undefined) {
      let callback = () => defaultStyleElement(cta[0], originalCta?.text ?? cta[0].textContent);

      if (usrHashValue) {
        const appliedVoucher = hasAnyVoucherApplied(firstProducts, t, locale, contextFilters, activatedPrevouchers, handleActivatePrevoucher);

        if (appliedVoucher === false) {
          // tiene usrhash y no tiene info vouchers, ocultamos
          callback = () => hideElement(cta[0]);
        } else {
          // tiene usrhash y tiene voucher applied hacemos lógica de texto verde
          callback = () => appliedVoucherElement(cta[0], t('listado.productos', 'discount.applied.BF22'));
        }
      }

      callback();
    }
  }, [shouldRecalculateVouchers, usrHashValue]);

  useEffect(() => {
    if (IS_CAMPER && autoappliedVoucher) {
      setVoucherApplied(true);
    }
  }, [autoappliedVoucher]);

  return {
    voucherApplied,
  };
}
